<div class="delete-category">
  <!-- Start header -->
  <div class="delete-category-header mb-0">
    <div class="ui-g-12 flex-between-center p-0">
      <div class="flex-start-center width-100p">
        <div class="center-bar">
          <div class="heading-box">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
        </div>
        <div class="part-description width-100p p-relative font-700 font-18 mt-1">Delete Category</div>
        <i id="part-close-dialog" class="far fa-times pointer dialog-close" (click)="handleDialogClose()"></i>
      </div>
    </div>
  </div>
  <!-- End header -->

  <!-- Start body -->
  <div *ngIf="option?.categoryLevel !== 'subSubCategory'" class="delete-category-body border-bottom-light">
    <div class="ui-g-12 p-0 font-14 mb-2">
      <span>
        Are you sure you want to delete "{{categoryName}}" category? There are
        <i *ngIf="loader.isLoading" class="fal fa-spinner rotate"></i>
        <span *ngIf="!loader.isLoading">{{associatedCategoryCount}}</span> items associated with
        this category. Please select an option to proceed:
      </span>
    </div>

    <div class="ui-g-12 p-0 font-14 font-400 mt-2 mb-2">
      <span>
        <app-radio-button [selectedValue]="deleteType" name="deleteCategoryOption" [label]="deleteCategoryOption[0].name"
        [value]="deleteCategoryOption[0].field" styleClassLabel="font-15 font-600 font-gray-35 pl-1"
        (appChange)="handleSelect('deleteType', $event)"></app-radio-button>
      <div class="font-13 ml-4 font-gray-35">{{deleteCategoryOption[0].text}}</div>
      </span>
    
      <span *ngIf="associatedCategoryCount > 0">
      <app-radio-button [selectedValue]="deleteType" name="deleteCategoryOption" [label]="deleteCategoryOption[1].name"
        [value]="deleteCategoryOption[1].field" styleClassLabel="font-15 font-600 font-gray-35 pl-1 mt-2"
        (appChange)="handleSelect('deleteType', $event)"></app-radio-button>
      <div class="font-13 ml-4 font-gray-35">{{deleteCategoryOption[1].text}}</div>
    </span>
    </div>

    <div *ngIf="deleteType === 'replaceAndDelete' && associatedCategoryCount > 0" class="ui-g-5 p-0 font-14 font-400 mb-2 mt-4 delete-category">
      <app-dropdown placeholder="Category*" scrollHeight="120px" field="name" [disabled]="!option?.itemType"
        [closeOnSelection]="true" [floatingLabel]="true" [hasEditableField]="false" [value]="selectedCategoryLevel"
        [isDropdownIconVisible]="true" [hasCustomItemTemplate]="true" [setPositionDynamically]="true"
        styleClassDropdownList="markup-dropdown-list-wrapper" [truncateString]="true" [fontSize]="14"
        [listItemFontSize]="14" [options]="categoryLevelResults" (appSelect)="handleSelect('replaceCategory', $event)">
        <ng-template let-item appTemplate="item">
          <div class="ui-g p-0 font-14 font-secondary-700">
            {{ item?.name }}
          </div>
        </ng-template>
      </app-dropdown>
    </div>
  </div>

  <div class="delete-body border-bottom-light">
    <div class="ui-g-12 p-0 font-14 font-500 p-2">
      <span>
        Are you sure you want to delete this category?
      </span>
    </div>
  </div>
  <!-- End body -->


  <!-- Start footer -->
  <div class="ui-g-12 flex-between-end dialog-footer part-footer border-top">
    <div class="delete-category-dialog-footer d-flex justify-content-end width-100p">
      <div>
        <button id="part-cancel-btn" class="btn btn-white btn-border pointer btn-submit ml-2"
          (click)="handleDialogClose()">
          Cancel
        </button>

        <button *ngIf="deleteType === 'replaceAndDelete'" id="part-save-btn"
          class="btn btn-delete btn-primary btn-submit pointer ml-2"
          [disabled]="!selectedCategoryLevel?._id || loader.isDeleting || loader.isLoading" (click)="handleSubmit()">
          <span>Replace and Delete</span>
          <i *ngIf="loader.isLoading" class="far fa-spinner rotate ml-2"></i>
        </button>

        <button *ngIf="deleteType === 'delete'" id="part-save-btn"
          class="btn btn-delete btn-primary btn-submit pointer ml-2" [disabled]="loader.isDeleting || loader.isLoading"
          (click)="handleSubmit()">
          <span>Delete</span>
          <i *ngIf="loader.isDeleting" class="far fa-spinner rotate ml-2"></i>
        </button>
      </div>
    </div>
  </div>
  <!-- End footer -->
</div>
